import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const containsUppercase = (ch: string) => /[A-Z]/.test(ch);
const containsLowercase = (ch: string) => /[a-z]/.test(ch);

const schema = z
	.object({
		password: z
			.string()
			.min(8, 'Строка должна содержать не менее 8 символов.')
			.refine(
				password => {
					let countOfUpperCase = 0,
						countOfLowerCase = 0,
						countOfNumbers = 0;

					for (let i = 0; i < password.length; i++) {
						let ch = password.charAt(i);
						if (!isNaN(+ch)) countOfNumbers++;
						else if (containsUppercase(ch)) countOfUpperCase++;
						else if (containsLowercase(ch)) countOfLowerCase++;
					}
					return !(countOfLowerCase < 1 || countOfUpperCase < 1 || countOfNumbers < 1);
				},
				{
					message: 'Пароль не соответствует требованиям сложности. Должны присутствовать прописные, строчные буквы и цифры',
				},
			),
		confirmPassword: z.string().min(8, 'Строка должна содержать не менее 8 символов.'),
	})
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Пароли не совпали',
			});
		}
	});

export const resolver = zodResolver(schema);



// WEBPACK FOOTER //
// src/components/reset-password/reset-password.schema.js